function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.385,
  y1: 0.058,
  x2: 0.59,
  y2: 1.29,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#db629b"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#7f26a8"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_20",
  "data-name": "Group 20",
  transform: "translate(-283.815 -393.657)"
}, React.createElement("path", {
  id: "Path_180",
  "data-name": "Path 180",
  d: "M368.649,433.052h17.3c-1.292-3.637-2.521-6.522-3.336-9.511a23.661,23.661,0,0,1,14.133-28.4c11.445-4.333,22.662,1.18,29.648,11.542,8.362,12.4,17.461,24.754,28.293,34.941,16.227,15.276,21.323,38.06,10.138,57.089a44.029,44.029,0,0,1-53.647,19.048c-20.577-7.937-31.876-29-27.263-50.834.733-3.473,1.514-6.942,2.444-11.2H368.706c.682,3.418,1.241,6.414,1.879,9.371,4.943,22.91-5.873,44.313-26.485,52.432a43.932,43.932,0,0,1-54.475-19.172c-11.16-19.6-5.688-41.57,11.686-57.639,10.377-9.6,18.964-21.56,26.633-33.558,6.881-10.763,18.868-16.6,30.453-11.818,11.658,4.82,17.132,17.194,13.065,29.544C370.691,427.245,369.855,429.578,368.649,433.052Zm58.484,15.078a27.927,27.927,0,0,0-28.776,27.484,28.633,28.633,0,0,0,28.174,29.463c15.674.128,29.164-13.267,29.071-28.871C455.5,460.781,442.868,448.327,427.132,448.13ZM356.18,477.722c.55-16.062-10.955-28.877-26.573-29.6-16.334-.749-29.639,11.155-30.3,27.121a28.742,28.742,0,0,0,27.839,29.827A28.291,28.291,0,0,0,356.18,477.722Z",
  fillRule: "evenodd",
  fill: "url(#linear-gradient)"
}), React.createElement("path", {
  id: "Path_181",
  "data-name": "Path 181",
  d: "M775.712,627.822c-9.731,5.835-18.181,10.9-26.669,16.011C750.895,631.881,758.169,627.272,775.712,627.822Z",
  transform: "translate(-342.493 -172.343)",
  fillRule: "evenodd",
  fill: "url(#linear-gradient)"
}), React.createElement("path", {
  id: "Path_182",
  "data-name": "Path 182",
  d: "M399.834,628.415c-8.783,5.42-17.579,10.847-26.086,16.114C375.216,632.3,383.494,627.01,399.834,628.415Z",
  transform: "translate(-66.188 -172.649)",
  fillRule: "evenodd",
  fill: "url(#linear-gradient)"
}));

var SvgBinoculars = function SvgBinoculars(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 187,
    height: 126.999,
    viewBox: "0 0 187 126.999",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBinoculars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Binoculars.4051b787.svg";
export { ForwardRef as ReactComponent };